import { reactive } from 'vue'
import actions from '@/store/gift/actions'
import getters from '@/store/gift/getters'
import state from '@/store/gift/state'

export const giftModule = {
    state: reactive(state),
    actions,
    getters,
}
